import IconArrowDown from '@/assets/icons/arrow_down.svg?inline'
import IconBulletin from '@/assets/icons/bulletin.svg?inline'
import IconChat from '@/assets/icons/chat.svg?inline'
import IconClose from '@/assets/icons/close.svg?inline'
import IconComment from '@/assets/icons/comment.svg?inline'
import IconCq from '@/assets/icons/cq.svg?inline'
import IconDocument from '@/assets/icons/document.svg?inline'
import IconFeishu from '@/assets/icons/feishu.svg?inline'
import IconForward from '@/assets/icons/forward.svg?inline'
import IconGift from '@/assets/icons/gift.svg?inline'
import IconGlasses from '@/assets/icons/glasses.svg?inline'
import IconGrid from '@/assets/icons/grid.svg?inline'
import IconHome from '@/assets/icons/home.svg?inline'
import IconLike from '@/assets/icons/like.svg?inline'
import IconLikeFill from '@/assets/icons/like_fill.svg?inline'
import IconLoading from '@/assets/icons/loading.svg?inline'
import IconLogoSspai from '@/assets/icons/logo_sspai.svg?inline'
import IconLogoTestv from '@/assets/icons/logo_testv.svg?inline'
import IconLoudspeaker from '@/assets/icons/loudspeaker.svg?inline'
import IconNext from '@/assets/icons/next.svg?inline'
import IconOther from '@/assets/icons/other.svg?inline'
import IconPause from '@/assets/icons/pause.svg?inline'
import IconPic from '@/assets/icons/pic.svg?inline'
import IconPlay from '@/assets/icons/play.svg?inline'
import IconPost from '@/assets/icons/post.svg?inline'
import IconPrev from '@/assets/icons/prev.svg?inline'
import IconQuestion from '@/assets/icons/question.svg?inline'
import IconQuote from '@/assets/icons/quote.svg?inline'
import IconRewind from '@/assets/icons/rewind.svg?inline'
import IconUnmute from '@/assets/icons/unmute.svg?inline'
import IconVideo from '@/assets/icons/video.svg?inline'

import Vue from 'vue'
Vue.component('IconArrowDown', IconArrowDown)
Vue.component('IconBulletin', IconBulletin)
Vue.component('IconChat', IconChat)
Vue.component('IconClose', IconClose)
Vue.component('IconComment', IconComment)
Vue.component('IconCq', IconCq)
Vue.component('IconDocument', IconDocument)
Vue.component('IconFeishu', IconFeishu)
Vue.component('IconForward', IconForward)
Vue.component('IconGift', IconGift)
Vue.component('IconGlasses', IconGlasses)
Vue.component('IconGrid', IconGrid)
Vue.component('IconHome', IconHome)
Vue.component('IconLike', IconLike)
Vue.component('IconLikeFill', IconLikeFill)
Vue.component('IconLoading', IconLoading)
Vue.component('IconLogoSspai', IconLogoSspai)
Vue.component('IconLogoTestv', IconLogoTestv)
Vue.component('IconLoudspeaker', IconLoudspeaker)
Vue.component('IconNext', IconNext)
Vue.component('IconOther', IconOther)
Vue.component('IconPause', IconPause)
Vue.component('IconPic', IconPic)
Vue.component('IconPlay', IconPlay)
Vue.component('IconPost', IconPost)
Vue.component('IconPrev', IconPrev)
Vue.component('IconQuestion', IconQuestion)
Vue.component('IconQuote', IconQuote)
Vue.component('IconRewind', IconRewind)
Vue.component('IconUnmute', IconUnmute)
Vue.component('IconVideo', IconVideo)
